import React  from "react";
import TimecardUpdateRequestTable from "./components/TimecardUpdateRequestTable";

const TimecardUpdateRequests = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
			<TimecardUpdateRequestTable/>      		
	      </div>
	    </div>
    );
};

export default TimecardUpdateRequests;